const getSpacesListOrder = (store) => {
	return store.SpacesListing.listOrder;
};

export default getSpacesListOrder;
